import React from 'react';
import { FormText } from '@tencent/tea-component/lib/form';
import classNames from 'classnames';
export function BuyFormText(_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b, style = _a.style, className = _a.className;
    return (React.createElement(FormText, { style: style, className: classNames('buy-item-text', "buy-item-text__" + theme, className) }, children));
}
/**
 * 同 BuyFormText
 * @deprecated 为了兼容旧接口而保留 BuyText 组件，将会在将来的版本中移除
 */
// export const BuyText = BuyFormText;
//# sourceMappingURL=BuyFormText.js.map